// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************\\
Footer (Form)
\\*********************************/
.roq-chat-window__footer {
  border-top: var(--border-pale);
  padding: var(--spacing-input-desktop) var(--spacing-small);
}

@media (max-width: 768px) {
  .roq-chat-window__footer {
    padding: var(--spacing-small);
  }
}

.roq-chat-send-message-form__buttons__button {
  align-items: center;
  display: flex;
  padding: var(--spacing-small);
}

.roq-chat-send-message-form__buttons__button svg {
  transform: scale(1.1);
}

/* Formatting buttons have a really bad UX, so disabled. */
.roq-chat-message-formatting-button {
  display: none;
}

.roq-chat-message-input {
  align-items: center;
  display: flex;
}

/* Wrapper of the wrapper around the input and placeholder */
.roq-chat-message-input__textarea {
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  flex-grow: 1;
}

/* Wrapper around the input and placeholder */
.roq-chat-editor__inner {
  flex-grow: 1;
  position: relative;
}

/* The input itself which is not an input tag */
.roq-chat-editor__inner__textarea {
  border: var(--border-dark);
  border-radius: var(--border-radius-tiny);
  cursor: text;
  max-height: var(--size-input-max-height);
  /* Must fix min height because of Safari mostly */
  min-height: var(--size-input-height);
  overflow-y: auto;
  padding: var(--spacing-small);
}

/* Handled on our side in ./index.css */
.roq-chat-editor__inner__textarea:focus {
  border: none;
  outline: none;
}

/* Placeholder */
.roq-chat-editor__inner__placeholder {
  align-items: center;
  color: var(--color-text-light);
  cursor: text;
  display: flex;
  inset: 0 auto 0 0;
  margin: var(--spacing-small);
  pointer-events: none;
  position: absolute;
}

.roq-chat-message-input-send-button {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: var(--spacing-small);
}

.roq-chat-editor--disabled,
.roq-chat-editor--disabled .roq-chat-editor__inner__textarea,
.roq-chat-message-input-send-button--no-action,
.roq-chat-message-input-send-button--disabled {
  color: var(--color-icons-inactive);
}

/********************************\\
Reply Message Popup
\\*********************************/

.roq-chat-window__footer__reply {
  background-color: var(--color-background);
  border: var(--border-dark);
  border-radius: var(--border-radius-tiny);
  color: var(--color-text-light);
  font-style: italic;
  padding: var(--spacing-small);
  position: relative;
  width: 100%;
}

.roq-chat-message-reply__header {
  font-weight: var(--font-semibold);
}

.roq-chat-message-reply__content {
  color: var(--color-text-light);
}

.roq-chat-message-reply__cancel-button {
  align-items: center;
  cursor: pointer;
  display: flex;
  inset: 0 0 0 auto;
  justify-content: center;
  padding: var(--spacing-small);
  position: absolute;
}

/********************************\\
Footer Mention
\\*********************************/

.roq-chat-mention-suggestions__list {
  background-color: var(--color-background);
  padding: var(--spacing-tiny);
}

.roq-chat-mention-suggestions__list__option {
  border-radius: var(--border-radius-tiny);
  padding: var(--spacing-tiny);
}

.roq-chat-mention-option__content {
  align-items: center;
  display: flex;
  gap: var(--spacing-small);
}

.roq-chat-mention-option--selected {
  background-color: var(--color-background-selected);
}

/********************************\\
Footer User Is Typing
\\*********************************/

.roq-chat-window__footer__typing {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/roqChat/_window-footer.css"],"names":[],"mappings":"AAAA;;kCAEkC;AAClC;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,YAAY;EACZ,wCAAwC;EACxC,iDAAiD;EACjD,oCAAoC;EACpC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,uCAAuC;AACvC;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;;kCAEkC;;AAElC;EACE,yCAAyC;EACzC,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;kCAEkC;;AAElC;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;kCAEkC;;AAElC;EACE,aAAa;AACf","sourcesContent":["/********************************\\\nFooter (Form)\n\\*********************************/\n.roq-chat-window__footer {\n  border-top: var(--border-pale);\n  padding: var(--spacing-input-desktop) var(--spacing-small);\n}\n\n@media (max-width: 768px) {\n  .roq-chat-window__footer {\n    padding: var(--spacing-small);\n  }\n}\n\n.roq-chat-send-message-form__buttons__button {\n  align-items: center;\n  display: flex;\n  padding: var(--spacing-small);\n}\n\n.roq-chat-send-message-form__buttons__button svg {\n  transform: scale(1.1);\n}\n\n/* Formatting buttons have a really bad UX, so disabled. */\n.roq-chat-message-formatting-button {\n  display: none;\n}\n\n.roq-chat-message-input {\n  align-items: center;\n  display: flex;\n}\n\n/* Wrapper of the wrapper around the input and placeholder */\n.roq-chat-message-input__textarea {\n  align-items: center;\n  display: flex;\n  flex-direction: row-reverse;\n  flex-grow: 1;\n}\n\n/* Wrapper around the input and placeholder */\n.roq-chat-editor__inner {\n  flex-grow: 1;\n  position: relative;\n}\n\n/* The input itself which is not an input tag */\n.roq-chat-editor__inner__textarea {\n  border: var(--border-dark);\n  border-radius: var(--border-radius-tiny);\n  cursor: text;\n  max-height: var(--size-input-max-height);\n  /* Must fix min height because of Safari mostly */\n  min-height: var(--size-input-height);\n  overflow-y: auto;\n  padding: var(--spacing-small);\n}\n\n/* Handled on our side in ./index.css */\n.roq-chat-editor__inner__textarea:focus {\n  border: none;\n  outline: none;\n}\n\n/* Placeholder */\n.roq-chat-editor__inner__placeholder {\n  align-items: center;\n  color: var(--color-text-light);\n  cursor: text;\n  display: flex;\n  inset: 0 auto 0 0;\n  margin: var(--spacing-small);\n  pointer-events: none;\n  position: absolute;\n}\n\n.roq-chat-message-input-send-button {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: var(--spacing-small);\n}\n\n.roq-chat-editor--disabled,\n.roq-chat-editor--disabled .roq-chat-editor__inner__textarea,\n.roq-chat-message-input-send-button--no-action,\n.roq-chat-message-input-send-button--disabled {\n  color: var(--color-icons-inactive);\n}\n\n/********************************\\\nReply Message Popup\n\\*********************************/\n\n.roq-chat-window__footer__reply {\n  background-color: var(--color-background);\n  border: var(--border-dark);\n  border-radius: var(--border-radius-tiny);\n  color: var(--color-text-light);\n  font-style: italic;\n  padding: var(--spacing-small);\n  position: relative;\n  width: 100%;\n}\n\n.roq-chat-message-reply__header {\n  font-weight: var(--font-semibold);\n}\n\n.roq-chat-message-reply__content {\n  color: var(--color-text-light);\n}\n\n.roq-chat-message-reply__cancel-button {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  inset: 0 0 0 auto;\n  justify-content: center;\n  padding: var(--spacing-small);\n  position: absolute;\n}\n\n/********************************\\\nFooter Mention\n\\*********************************/\n\n.roq-chat-mention-suggestions__list {\n  background-color: var(--color-background);\n  padding: var(--spacing-tiny);\n}\n\n.roq-chat-mention-suggestions__list__option {\n  border-radius: var(--border-radius-tiny);\n  padding: var(--spacing-tiny);\n}\n\n.roq-chat-mention-option__content {\n  align-items: center;\n  display: flex;\n  gap: var(--spacing-small);\n}\n\n.roq-chat-mention-option--selected {\n  background-color: var(--color-background-selected);\n}\n\n/********************************\\\nFooter User Is Typing\n\\*********************************/\n\n.roq-chat-window__footer__typing {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
